"use client";

import { useCallback, useState } from "react";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export default function Page() {
  const [code, setCode] = useState("");
  const handleContinue = useCallback(() => {
    window.location.href = `https://a.pop.loans/${code}`;
  }, [code]);

  function handleInput(event: React.ChangeEvent<HTMLInputElement>) {
    setCode(event.target.value);
  }

  return (
    <div className="flex min-h-screen w-screen flex-col">
      <div className="flex w-full flex-1 items-start justify-center sm:mt-[120px]">
        <div className="flex w-full max-w-[480px] flex-col gap-6 p-6">
          <div className="gap-1">
            <p className="text-txt-primary text-2xl font-normal">
              Claim your offer
            </p>
            <p className="text-txt-tertiary text-sm">
              Enter the Offer Code on the invitation your received.
            </p>
          </div>

          <Input
            value={code}
            type="text"
            placeholder={"https://a.pop.loans/"}
            onInput={handleInput}
            className="w-full"
            // containerClass="w-full"
          />
          <Button
            className="h-12 w-full rounded-xl px-5 py-3 text-sm font-medium"
            onClick={handleContinue}
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
}
